/**
 * Date: 3 Nov 2025
 * Creator: yunshen
 * Desription: Implementing a successful ab test. Due to workload, can't individually update. So I'll put this in TODO first.
 */

(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    const handle = window.location.pathname.split("/").pop();
    const addons = getAddOns(handle);

    if (!addons || !addons.length) return;

    $(".addon-section").remove();
    addStyle();
    addCrossSell();
  }

  function addStyle() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      .groupsell-wrap {
        display: none;
      }

      .addon-list {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        gap: 10px;
      }
      .addon-list p {
        margin: 0;
      }
      .addon-list .addon-item {
        display: grid;
        align-items: center;
        gap: 8px;
        grid-template-columns: auto 1fr 3fr auto;
        padding: 1rem;
        background: #fff;
        border: 1px solid #c4c4c4;
        cursor: pointer;
      }
      .addon-list .addon-item:has(input:checked) {
        background: #f2e5e5;
        border-color: #7a0000;
      }
      .addon-list .addon-item:has(input:checked) .radio-button {
        border-color: #7a0000;
      }
      .addon-list .addon-item:has(input:checked) .radio-button .tick {
        display: block;
      }
      .addon-list .addon-item .image_container {
        position: relative;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
      }
      .addon-list .addon-item .image_container img {
        max-height: 520px;
      }
      .addon-list .addon-item .info_container .product_title {
        font-weight: 700;
      }
      .addon-list .addon-item .info_container .product_description {
        font-size: 14px;
      }
      .addon-list .addon-item .info_container .product_variants {
        display: flex;
        gap: 12px;
        margin-top: 6px;
      }
      .addon-list .addon-item .info_container .product_variants .item {
        padding: 5px 10px;
        color: #d1d1d1;
        border: 1px solid #d1d1d1;
        cursor: pointer;
        position: relative;
        width: 46px;
        height: 46px;
      }
      .addon-list .addon-item .info_container .product_variants .item:after {
        position: absolute;
        content: "";
        border: 2px solid #fff;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .addon-list .addon-item .info_container .product_variants .item.active {
        color: #7a0001;
        border-color: #7a0001;
        border-width: 2px;
      }
      .addon-list .addon-item .price_container {
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-end;
        gap: 4px;
        text-align: right;
        justify-self: flex-end;
      }
      .addon-list .addon-item .info_container .product_description .desc-sep {
        display: none;
      }

      @media (min-width: 1024px) {
        .addon-list .addon-item .info_container .product_description br {
          display: none;
        }
        .addon-list .addon-item .info_container .product_description .desc-sep {
          display: inline;
        }
      }
    `;
    document.head.append(style);
  }

  async function addCrossSell() {
    const handle = window.location.pathname.split("/").pop();
    const addons = getAddOns(handle);

    const section = document.createElement("div");
    const $section = $(section);
    $section.addClass("addon-section");

    $section.html(`
      <p><b style="font-weight: 600">Add-on:</b> Monitor Arms</p>
      <div class="addon-list"></div>
    `);
    /*
    $section.prepend(`
      <div class="free_gift_banner layout2 monitor-freebie">
        <div class="free-gift">
          <img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/freebie_monitor_arm.png?v=1773215176" alt="Free Monitor Arm">
          <div class="info-wrapper">
            <div class="title-wrapper">
              <span class="free-tag">EXCLUSIVE PROMO</span>
              <span class="title">Extra 15% OFF Monitor Arm when you bundle with Monitor</span>
            </div>
          </div>
        </div>
      </div>
    `);
    */

    for (const addonHandle of addons) {
      try {
        const data = await (await fetch(`/products/${addonHandle}.js`)).json();

        if (!data.available) continue;

        let shortDescription = "";

        try {
          const htmlString = await (
            await fetch(
              `/products/${addonHandle}?section_id=product-metafields`,
            )
          ).text();
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(htmlString, "text/html");
          shortDescription = htmlDoc
            .querySelector(".shopify-section")
            .innerHTML.replace(
              /<br\s*\/?>/gi,
              '<br><span class="desc-sep"> | </span>',
            );
        } catch (error) {
          console.error(error);
        }

        const radioButton = `
          <svg class="tick" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1299" height="1299" viewBox="0 0 1299 1299">
            <image x="1" y="1" width="1298" height="1298" xlink:href="data:img/png;base64,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"></image>
          </svg>
        `.trim();

        let product_variants = "";
        let availableVariants = data.variants.filter((x) => x.price > 0 && x.available);
        if (availableVariants.length > 1 && data.id != 8818753470691) {
          const whiteMonitorHandles = [
            "prism-u270-pro-testurl",
            "prism-u270-ultra-testurl",
            "prism-u320-pro-testurl",
            "prism-u320-ultra-testurl",
            "prism-u320-6k-testurl",
          ];
          if (whiteMonitorHandles.includes(handle) && data.title == "Arc Beam") availableVariants.reverse();

          availableVariants.forEach((variant, index) => {
            product_variants += `<div class="item ${index == 0 ? "active" : ""} variant-${variant.title.toLowerCase().replace(" ", "-")}" data-variant-id="${variant.id}" data-variant-image="${variant.featured_image?.src || data.featured_image}" data-sel-text="${variant.title}"></div>`;
          });

          product_variants = `
            <p style="font-size: 14px;margin-top: 8px;">
              <span style="font-weight: 600;">Colour:</span>
              <span class="sel">
                ${availableVariants[0].title}
              </span>
            </p>
            <div class="product_variants">${product_variants}</div>
            ${(data.title == "Arc Beam") ? 
              `<p style="font-size: 14px;font-weight: 600;margin-top: 8px;font-style: italic;">
                Pre-Order: Arrives in Early December
              </p>` : ""
            }
          `;
        }

        const label = document.createElement("label");
        const $label = $(label);

        //update: to get the lowest price that is not zero or from bundle
        const prices = data.variants
          .map((v) => Number(v.price))
          .filter((p) => p > 0); // remove zero prices

        const lowestNonZeroPrice = prices.length
          ? Math.min(...prices)
          : data.price_max; // fallback safety

        $label.addClass("addon-item");
        $label.html(`
          <input type="checkbox" name="addon_monitor_arm" value="${data.variants[0].id}" class="hide" />
          <div class="selector">
            <div class="radio-button">${radioButton}</div>
          </div>
          <div class="image_container">
            <img src="${availableVariants[0].featured_image?.src || data.featured_image}" alt="" width="" height="" />
          </div>
          <div class="info_container  monitor-${data.variants[0].id}">
            <p class="product_title">${data.title}</p>
            <p class="product_description">${shortDescription}</p>
            ${product_variants}
          </div>
          <div class="price_container">
            <p class="compare_at_price">${theme.Currency.formatMoney(data.compare_at_price)}</p>
            <p class="price">${theme.Currency.formatMoney(lowestNonZeroPrice)}</p>
          </div>
        `);

        $section.find(".addon-list")[0].append(label);
      } catch (error) {
        console.error("Error fetching addon product:", addonHandle);
        console.error(error);
        continue;
      }
    }

    const parent = $(".product-single__meta");
    if (parent.length) {
      if ($section.find(".addon-item").length) {
        parent[0].append(section);

        const $variants = $section.find(".product_variants .item");
        $variants.on("click", function (e) {
          e.stopPropagation();
          e.preventDefault();

          $(this).addClass("active");
          $(this).siblings(".item").removeClass("active");

          const variantId = $(this).attr("data-variant-id");
          const imageSrc = $(this).attr("data-variant-image");
          const selText = $(this).attr("data-sel-text");

          const closestInput = $(this)
            .closest(".addon-item")
            .find("input[name='addon_monitor_arm']");
          closestInput.val(variantId);
          closestInput.trigger("change");

          const closestImage = $(this)
            .closest(".addon-item")
            .find(".image_container img");
          closestImage.attr("src", imageSrc);
          
          const closestSel = $(this)
            .closest(".addon-item")
            .find(".sel");
          closestSel.html(selText);
        });

        const $inputs = $section.find("[name='addon_monitor_arm']");
        $inputs.on("change", function () {
          if (this.checked) {
            $inputs.not(this).prop("checked", false);
          }

          const value = this.checked ? this.value : "";

          $(".selectedgroupsell").text(value);
          updateLinks();

          const $prodBundle = $("#ProdBundle");
          if (value) {
            $prodBundle.attr("data-vid", value);
            $prodBundle.attr("data-vtype", "Monitor Arms");
          } else {
            $prodBundle.attr("data-vid", "");
            $prodBundle.attr("data-vtype", "");
          }
        });
      }
    }
  }

  function getAddOns(handle) {
    const list = getList();
    return list.find((x) => x.handle == handle)?.addons || [];
  }

  function getList() {
    const ARMS = {
      "arc-lite": "arc-lite",
      "arc-lite-dual": "arc-lite-dual",
      "arc-stealth-single": "arc-stealth-single",
      "arc-stealth-dual": "arc-stealth-dual",
      "arc-stealth-pro": "arc-stealth-pro",
      "arc-stealth-pro-add-on-kit": "arc-stealth-pro-add-on-kit",
      "arc-neo": "arc-neo",
      "arc-neo-dual": "arc-neo-dual",
      "arc-02": "arc-02",
      "arc-01":"arc-01",
      "arc-beam": "arc-beam",
      "arc-beam-dual": "arc-beam-dual",
      "arc-rex-dual": "arc-rex-dual",
      "arc-titan": "arc-titan",
      "arc-titan-dual": "arc-titan-dual",
      "arc-titan-pro": "arc-titan-pro",
      "arc-titan-pro-add-on-kit": "arc-titan-pro-add-on-kit",
      "vantage-ascend-dual": "vantage-ascend-dual",
      "vantage-dual": "vantage-dual",
      "vantage-triple": "vantage-triple",
      "elevate-u1": "elevate-u1",
      "laptop-holder": "laptop-holder",
      "arc-opus": "arc-opus",
    };

  const MONITORS = [
    {
      handle: "prism-w290u",
      addons: [
        ARMS["arc-lite"],
        ARMS["arc-titan"],
        ARMS["arc-titan-pro"],
      ],
    },
    {
      handle: "prism-w340u-pro",
      addons: [
        ARMS["arc-01"],
        ARMS["arc-titan"],
        ARMS["arc-titan-pro"],
      ],
    },
    {
      handle: "prism-w220v",
      addons: [
        ARMS["arc-lite"],
        ARMS["arc-beam"],
        ARMS["arc-01"],
      ],
    },
    {
      handle: "prism-x240",
      addons: [
        ARMS["arc-beam"],
        ARMS["arc-opus"],
        ARMS["arc-01"],
      ],
    },
    {
      handle: "prism-c240",
      addons: [
        ARMS["arc-lite"],
        ARMS["arc-opus"],
        ARMS["elevate-u1"],
      ],
    },
    {
      handle: "prism-f250i",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-beam"],
        ARMS["arc-01"],
      ],
    },
    {
      handle: "prism-f250i-300hz",
      addons: [
        ARMS["elevate-u1"],
        ARMS["arc-beam"],
        ARMS["arc-01"],
      ],
    },
    {
      handle: "prism-pg25x",
      addons: [
        ARMS["arc-lite"],
        ARMS["arc-titan"],
        ARMS["arc-01"],
      ],
    },
    {
      handle: "prism-pg25x-pro",
      addons: [
        ARMS["arc-lite"],
        ARMS["arc-titan"],
        ARMS["arc-01"],
      ],
    },
    {
      handle: "prism-w240",
      addons: [
        ARMS["arc-lite"],
        ARMS["elevate-u1"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-w250",
      addons: [
        ARMS["arc-lite"],
        ARMS["elevate-u1"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-x270-240hz",
      addons: [
        ARMS["arc-beam"],
        ARMS["arc-opus"],
        ARMS["arc-titan"],
      ],
    },
    {
      handle: "prism-x270-pro",
      addons: [
        ARMS["arc-stealth-single"],
        ARMS["arc-opus"],
        ARMS["arc-titan"],
      ],
    },
    {
      handle: "prism-f270i",
      addons: [
        ARMS["arc-lite"],
        ARMS["elevate-u1"],
        ARMS["arc-titan"],
      ],
    },
    {
      handle: "prism-f270i-pro",
      addons: [
        ARMS["arc-opus"],
        ARMS["arc-beam"],
        ARMS["arc-lite"],
      ],
    },
    {
      handle: "prism-f270i-ultra",
      addons: [
        ARMS["elevate-u1"],
        ARMS["arc-opus"],
        ARMS["arc-titan"],
      ],
    },
    {
      handle: "prism-pg27x-pro",
      addons: [
        ARMS["arc-beam"],
        ARMS["arc-titan"],
        ARMS["arc-01"],
      ],
    },
    {
      handle: "prism-pg27f-ultra",
      addons: [
        ARMS["arc-stealth-single"],
        ARMS["arc-titan"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-27g1x-pro",
      addons: [
        ARMS["arc-stealth-single"],
        ARMS["arc-beam"],
      ],
    },
    {
      handle: "prism-27g1x-ultra",
      addons: [
        ARMS["arc-beam"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-c270",
      addons: [
        ARMS["arc-stealth-single"],
        ARMS["arc-lite"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-w270-1",
      addons: [
        ARMS["arc-01"],
        ARMS["arc-opus"],
        ARMS["arc-lite"],
      ],
    },
    {
      handle: "prism-w270pro",
      addons: [
        ARMS["arc-lite"],
        ARMS["arc-opus"],
        ARMS["arc-titan"],
      ],
    },
    {
      handle: "prism-w270c-pro",
      addons: [
        ARMS["arc-stealth-single"],
        ARMS["elevate-u1"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-w270-ultra",
      addons: [
        ARMS["elevate-u1"],
        ARMS["arc-opus"],
        ARMS["arc-01"],
      ],
    },
    {
      handle: "prism-w270c-ultra",
      addons: [
        ARMS["elevate-u1"],
        ARMS["arc-beam"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-x300",
      addons: [
        ARMS["elevate-u1"],
        ARMS["arc-titan"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-x315-pro",
      addons: [
        ARMS["elevate-u1"],
        ARMS["arc-titan"],
        ARMS["arc-beam"],
      ],
    },
    {
      handle: "prism-c315-max",
      addons: [
        ARMS["elevate-u1"],
        ARMS["arc-titan"],
        ARMS["arc-beam"],
      ],
    },
    {
      handle: "prism-32g1x-ultra",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-beam"],
        ARMS["arc-01"],
      ],
    },
    {
      handle: "prism-34g1x-pro",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-opus"],
        ARMS["arc-beam"],
      ],
    },
    {
      handle: "prism-x340-pro-200hz",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-opus"],
        ARMS["arc-01"],
      ],
    },
    {
      handle: "x340-pro-evo",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-titan-pro"],
        ARMS["arc-beam"],
      ],
    },
    {
      handle: "prism-pg34f-pro",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-beam"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-c340c-pro",
      addons: [
        ARMS["arc-beam"],
        ARMS["arc-01"],
        ARMS["arc-titan"],
      ],
    },
    {
      handle: "prism-pg400u-pro",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-titan-dual"],
        ARMS["arc-titan-pro"],
      ],
    },
    {
      handle: "prism-p438",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-titan-dual"],
        ARMS["arc-titan-pro"],
      ],
    },
    {
      handle: "prism-x450-pro",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-titan-dual"],
        ARMS["arc-titan-pro"],
      ],
    },
    {
      handle: "prism-x490",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-titan-dual"],
        ARMS["arc-titan-pro"],
      ],
    },
    {
      handle: "prism-x490-pro",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-titan-dual"],
        ARMS["arc-titan-pro"],
      ],
    },
    {
      handle: "prism-49al",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-titan-dual"],
        ARMS["arc-titan-pro"],
      ],
    },
    {
      handle: "prism-49al-240hz",
      addons: [
        ARMS["arc-titan"],
        ARMS["arc-titan-dual"],
        ARMS["arc-titan-pro"],
      ],
    },
    {
      handle: "prism-u270-pro-testurl",
      addons: [
        ARMS["arc-beam"],
        ARMS["arc-01"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-u270-ultra-testurl",
      addons: [
        ARMS["arc-beam"],
        ARMS["arc-01"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-u320-pro-testurl",
      addons: [
        ARMS["arc-beam"],
        ARMS["arc-01"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-u320-ultra-testurl",
      addons: [
        ARMS["arc-beam"],
        ARMS["arc-01"],
        ARMS["arc-opus"],
      ],
    },
    {
      handle: "prism-u320-6k-testurl",
      addons: [
        ARMS["arc-beam"],
        ARMS["arc-01"],
        ARMS["arc-opus"],
      ],
    },

    // cut off point cuz not in the list

    {
      handle: "roam-ultra-32",
      addons: [],
    },
  ];

    return MONITORS;
  }
})();
